import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { TermsContext } from "../../../utils/Context";
import { MULTI, SINGLE, Selector } from "../../Selectors/Selector";

const AcademicYearSelect = ({
  type = MULTI,
  id = "academic-year-select",
  label,
  selectHandler,
  noFutureYears = false,
  selectedAcademicYears,
  size,
  clear,
}) => {
  const { t } = useTranslation();
  const { academicYears } = useContext(TermsContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (academicYears) {
      const currentDate = new Date();
      let academicYearsList = [...academicYears];

      if (noFutureYears) {
        academicYearsList = academicYearsList.filter(
          (year) => new Date(year.start_at) <= currentDate
        );
      }

      setOptions(
        academicYearsList
          .sort((a, b) => new Date(a.start_at) - new Date(b.start_at))
          .map((year) => ({ ...year, label: year.name }))
      );
    }
  }, [academicYears, noFutureYears]);

  const selectWrapper = (yearIds) => {
    const selectedYears = academicYears.filter((year) =>
      yearIds.includes(year.id)
    );
    selectHandler(selectedYears);
  };

  return (
    <Selector
      type={type}
      id={id}
      label={label ?? t("academicYears.academicYears")}
      options={options}
      selectHandler={selectWrapper}
      clear={clear}
      size={size}
      selectedOptions={type === MULTI ? selectedAcademicYears : null}
      selectedItemId={type === SINGLE ? selectedAcademicYears : null}
    />
  );
};

export default AcademicYearSelect;
